
import { CHANGE_STATUS, GET_USER_ERROR, GET_USER_LOADER, GET_USER_SUCCESS, LOGIN_ERR, LOGIN_LOADER, LOGIN_SUCCESS, UPDATE_PROFILE } from '../../types';
import { IAuthState, IAuthAction } from '../../types/auth';

const getInitialState = (): IAuthState => {
  const authInfo = JSON.parse(localStorage.getItem('authInfo') || null);
  const token = localStorage.getItem('token');
  return authInfo
    ? {
      loginLoader: true,
      user: authInfo,
      token,
      userStatus: true,
      authError: '',
      getUserLoader: true,
      getUserError: '',
      getUserStatus: 'done',
    }
    : {
      loginLoader: false,
      user: null,
      token: '',
      userStatus: false,
      authError: '',
      getUserLoader: true,
      getUserError: '',
      getUserStatus: 'not Done',
    };
};

export default function (state = getInitialState(), action: IAuthAction) {
  switch (action.type) {
    case LOGIN_LOADER: {
      return {
        ...state,
        loginLoader: action.payload,
      };
    }
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload.data,
        token: action.tokens.data.token,
        userStatus: action.payload.success,
      };
    case LOGIN_ERR:
      return {
        ...state,
        authError: action.payload,
      };
    case GET_USER_LOADER:
      return {
        ...state,
        getUserLoader: action.payload,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        user: action.payload.data,
        token: action.token,
        userStatus: action.payload.success,
        getUserStatus: 'done',
      };
    case GET_USER_ERROR:
      return {
        ...state,
        getUserError: action.payload,
        getUserStatus: 'not Found',
      };
    case CHANGE_STATUS:
      return {
        ...state,
        getUserStatus: 'not done',
      };
    case UPDATE_PROFILE:
      return {
        ...state,
        user: action.payload,
      }   


    default:
      return state;
  }
}
